import Store from '../store'

const Mailboxes = {

    isLastActiveEmail: (mailbox) => {
        const activeMailboxes = Store.getters.mailboxes.filter(box => box.isActive).map(box => box.email)
        return activeMailboxes.length === 1 && activeMailboxes[0] === mailbox.email
    },

    mailboxStatusIcon: (mailbox) => {
        if (Mailboxes.isLastActiveEmail(mailbox)) {
            return '/img/newsletters-v2/checkbox-2-grey.svg'
        } else {
            return `/img/newsletters-v2/checkbox-2-${mailbox.isActive ? 'on' : 'off'}.svg`
        }
    },

    isInvalidMailbox: (mailbox) => {
        return !!mailbox.providerShutdown || !!mailbox.invalidGrant
    },

    isInvalidGrant: (mailbox) => {
        return !!mailbox.invalidGrant
    },

    isProviderShutdown: (mailbox) => {
        return !!mailbox.providerShutdown
    },

    itCanBeDisabled: (mailbox) => {
        return !Mailboxes.isInvalidMailbox(mailbox) && !Mailboxes.isLastActiveEmail(mailbox)
    }

}

export default Mailboxes

